import React from 'react';

import { OrderDirection } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';

// These should be enum values of TableOrderField *AND* DatabaseTableOrderField.
// The compiler won't let us assign both enum types at once, so we're just listing out the string literals.
export type TablesValidSortFields =
  'NAME' | 'DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT' | 'DOWNSTREAM_DATASOURCES_COUNT' | 'DOWNSTREAM_WORKBOOKS_COUNT' | 'IS_CERTIFIED' | 'PROJECT_NAME';

export const TablesDefaultDirections: DefaultDirections<TablesValidSortFields> = {
  NAME: OrderDirection.ASC,
  DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT: OrderDirection.DESC,
  DOWNSTREAM_DATASOURCES_COUNT: OrderDirection.DESC,
  DOWNSTREAM_WORKBOOKS_COUNT: OrderDirection.DESC,
  IS_CERTIFIED: OrderDirection.DESC, // Certified items at the top
  PROJECT_NAME: OrderDirection.ASC,
};

export const TablesDefaultSortField = 'DOWNSTREAM_WORKBOOKS_COUNT';

export function TablesGridSortProvider(
  props: Pick<SortProviderProps<TablesValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<TablesValidSortFields>
      validOrderFieldsWithDefaultDirections={TablesDefaultDirections}
      defaultField={TablesDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
